import {
  CircularProgress,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { setUsers } from "../../actions/usersActions";
import { colors, metrics } from "../../styles";
import MissionService from "../../tools/MissionService";
import Card from "./Card";
import OptionsBar from "./OptionsBar";
import FlightSchedule from "../../components/FlightSchedule";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shutle: [],
      page: 1,
      loading: true,
      openSearch: false,
      clean: true,
      totalPages: 1,
      viewCalendar: "cards",
      itemsPerPage: 8,
      filterByStatus: "",
    };
  }
  getMissions = (page, itemsPerPage) => {
    this.setState({ loading: true });
    if (this.state.filterByStatus !== "") {
      MissionService.getByStatus(
        this.state.filterByStatus,
        itemsPerPage,
        page
      ).then((result) => {
        this.setState({ loading: false, shutle: [] });
        if (result.ok) {
          console.info("INFO ->", result.response);
          this.setState({
            shutle: result.response.docs,
            loading: false,
            totalPages: result.response.totalPages,
            clean: false,
          });
        }
      });
    } else {
      MissionService.get(page, itemsPerPage).then((response) => {
        this.setState({ loading: false, shutle: [] });
        if (response.ok) {
          this.setState({
            shutle: response.response.docs,
            loading: false,
            page: response.response.currentPage,
            totalPages: response.response.totalPages,
          });
        }
      });
    }
  };

  componentWillMount() {
    const viewCalendar = sessionStorage.getItem("viewCalendar");
    console.log(viewCalendar);
    this.setState({ loading: true, viewCalendar });
    if (viewCalendar === "calendar") this.getMissions(1, 9999);
    else this.getMissions(this.state.page, this.state.itemsPerPage);
  }

  handleRefresh = () => {
    this.setState({ loading: true, shutle: [], filterByStatus: "", page: 1 });
    MissionService.get(this.state.page, this.state.itemsPerPage).then(
      (response) => {
        this.setState({ loading: false, shutle: [] });
        if (response.ok) {
          this.setState({
            shutle: response.response.docs,
            loading: false,
            totalPages: response.response.totalPages,
          });
        }
      }
    );
    this.setState({ clean: true });
  };

  handleSearch = (text) => {
    this.setState({ loading: true, shutle: [] });
    MissionService.search(text, this.state.page, this.state.itemsPerPage).then(
      (result) => {
        //console.log(result)
        this.setState({ loading: false, shutle: [] });
        if (result.ok) {
          this.setState({ shutle: [] });
          console.info("INFO ->", result.ok);
          this.setState({
            shutle: result.response.docs,
            loading: false,
            totalPages: 1,
          });

          // this.setState({
          //   shutle: result.response.docs,
          // });
        }
      }
    );
  };

  handleDate = async (value) => {
    //console.log('date:',value);
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    return null;
  };

  handleNull = async (value) => {
    if (value === "") {
      return value;
    } else if (value) return value;
    return null;
  };

  handleCustomSearch = async (text) => {
    this.handleOpenDialog();
    //console.log('radom search:',text)
    this.setState({ loading: true });
    let edit = text;
    edit.passenger = await this.handleNull(edit.passenger);
    edit.aircraft_type = await this.handleNull(edit.aircraft_type);
    edit.aircraft = await this.handleNull(edit.aircraft);
    edit.to = await this.handleNull(edit.to);
    edit.from = await this.handleNull(edit.from);
    edit.initial_date = await this.handleDate(edit.initial_date);
    edit.final_date = await this.handleDate(edit.final_date);
    text = edit;
    MissionService.customSearch(text).then((result) => {
      this.setState({ loading: false });
      if (result.ok) {
        //console.log('radom search:',text)
        //console.log('result search:',result)
        this.setState({
          shutle: result.response.docs,
        });
      }
    });
    this.setState({ clean: false });
  };

  handleSearchByStatus = (text) => {
    this.setState({ loading: true, shutle: [], filterByStatus: text, page: 1 });
    MissionService.getByStatus(text, this.state.itemsPerPage, 1).then(
      (result) => {
        this.setState({ loading: false });
        if (result.ok) {
          console.info("INFO ->", result.response);
          this.setState({
            shutle: result.response.docs,
            loading: false,
            totalPages: result.response.totalPages,
            clean: false,
          });
        }
      }
    );
    this.setState({ clean: false });
  };

  handleOpenDialog = () => {
    this.setState({ openSearch: !this.state.openSearch });
  };
  handleChangeSwitch = (_, value) => {
    if (value) {
      this.setState({ viewCalendar: "calendar" });
      sessionStorage.setItem("viewCalendar", "calendar");
      this.getMissions(1, 9999);
    } else {
      this.setState({ viewCalendar: "cards" });
      sessionStorage.setItem("viewCalendar", "cards");
      this.getMissions(this.state.page, this.state.itemsPerPage);
    }
  };

  render() {
    return (
      <Grid container>
        <OptionsBar
          clean={this.state.clean}
          openSearch={this.state.openSearch}
          handleOpenDialog={this.handleOpenDialog}
          handleSearch={this.handleSearch}
          handleCustomSearch={this.handleCustomSearch}
          handleSearchByStatus={this.handleSearchByStatus}
          handleRefresh={this.handleRefresh}
          handleChangeSwitch={this.handleChangeSwitch}
          viewCalendar={this.state.viewCalendar}
        />
        {this.state.loading && (
          <Grid
            container
            direction="row"
            justify="center"
            style={{ marginTop: 20 }}
          >
            <CircularProgress size={60} />
          </Grid>
        )}
        {!this.state.loading && this.state.shutle.length === 0 && (
          <Grid container justify="center">
            <Typography style={{ fontSize: 20, marginTop: 20 }}>
              Não há missões cadastradas
            </Typography>
          </Grid>
        )}
        <Grid container style={styles.page}>
          {this.state.viewCalendar === "calendar" ? (
            this.state.loading ? (
              <CircularProgress></CircularProgress>
            ) : (
              <FlightSchedule
                missions={this.state.shutle.flatMap((mission) =>
                  [...mission.flight_stages].map((stage, index) => {
                    return {
                      id: mission.id,
                      title: `${mission.flight_denomination} - Etapa ${
                        index + 1
                      }`,
                      start: `${stage.departure_date}`,
                      end: `${stage.arrival_date}`,
                    };
                  })
                )}
              />
            )
          ) : (
            <Grid container item md={12} spacing={8}>
              {!this.state.loading &&
                this.state.shutle.length > 0 &&
                this.state.shutle.map((element, index) => {
                  console.log(element);
                  return <Card key={index} {...element} />;
                })}
            </Grid>
          )}
        </Grid>
        {this.state.viewCalendar !== "calendar" &&
          this.state.totalPages > 1 && (
            <Grid container justify="center">
              <Grid item>
                <IconButton
                  color="primary"
                  disabled={this.state.page == 1}
                  onClick={() => {
                    let page = this.state.page > 1 ? this.state.page - 1 : 1;
                    if (this.state.page === page) return;
                    this.setState({
                      page,
                    });
                    this.getMissions(page, this.state.itemsPerPage);
                  }}
                >
                  <ChevronLeft />
                </IconButton>
                <IconButton
                  color="primary"
                  disabled={this.state.page == this.state.totalPages}
                  onClick={() => {
                    let page = this.state.page + 1;
                    if (page > this.state.totalPages) return;
                    this.setState({
                      page,
                    });
                    this.getMissions(page, this.state.itemsPerPage);
                  }}
                >
                  <ChevronRight />
                </IconButton>
              </Grid>
            </Grid>
          )}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  setUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

const styles = {
  page: {
    padding: metrics.paddingPage,
  },
  menuLeft: {},
  ibox: {
    backgroundColor: colors.white,
    padding: metrics.padding,
    elevation: 10,
  },
};



// WEBPACK FOOTER //
// ./src/routes/home/index.js